import React, { useState } from 'react';
import { Form, FormInstance, Typography, Input, Row, Col } from 'antd';
import { NameOf } from 'src/utils';
import LocationInfoFormDTO from '../models/generated/LocationInfoDTO';


export interface LocationInfoFormProps {
    form: FormInstance<any>;
}
const LocationInfoForm: React.FC<LocationInfoFormProps> = ({ form }) => {
    //const [form] = Form.useForm();
    const layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    };
    return (
        <Form
            name='locationInfoForm'
            colon={false}
            disabled={true}
            layout='horizontal' 
            form={form}
        >
            <fieldset>
                <legend>Location Information</legend>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label={<Typography.Text strong>Account #</Typography.Text>} {...layout }
                            name={NameOf<LocationInfoFormDTO>('accountNumber')}
                        >
                            <Input></Input>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label={<Typography.Text strong>Account Name</Typography.Text>} {...layout}
                            name={NameOf<LocationInfoFormDTO>('accountName')}
                        >
                            <Input></Input>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label={<Typography.Text strong>Location ID</Typography.Text>} {...layout}
                            name={NameOf<LocationInfoFormDTO>('locationId')}
                        >
                            <Input></Input>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label={<Typography.Text strong>Code</Typography.Text>} {...layout}
                            name={NameOf<LocationInfoFormDTO>('code')}
                        >
                            <Input></Input>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label={<Typography.Text strong>Location Name</Typography.Text>} {...layout}
                            name={NameOf<LocationInfoFormDTO>('locationName')}
                        >
                            <Input></Input>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label={<Typography.Text strong>POS</Typography.Text>} {...layout}
                            name={NameOf<LocationInfoFormDTO>('pos')}
                        >
                            <Input></Input>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label={<Typography.Text strong>SMS</Typography.Text>} {...layout}
                            name={NameOf<LocationInfoFormDTO>('sms')}
                        >
                            <Input></Input>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label={<Typography.Text strong>Inactive</Typography.Text>} {...layout}
                            name={NameOf<LocationInfoFormDTO>('inactive')}
                        >
                            <Input></Input>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label={<Typography.Text strong>Tenant</Typography.Text>} {...layout}
                            name={NameOf<LocationInfoFormDTO>('tenant')}
                        >
                            <Input></Input>
                        </Form.Item></Col>
                </Row>
            </fieldset>
        </Form>
    );
};

export default LocationInfoForm;